package dev.lingvo.shared

import kotlinx.serialization.Serializable

@Serializable
data class StoreAppChoiceDto(val storeAppRef: String, val displayName: String, val bundleId: String? = null)

@Serializable
data class StoreConnectionCheckRequest(val storeAppRef: String)

@Serializable
data class StoreAllowedAppsRequest(val appRefs: List<String>)

@Serializable
enum class StoreCapabilityStatus { VERIFIED, ROLE_BLOCKED, STATE_BLOCKED, UNAVAILABLE }

/** Capability probes, not an inferred role name. Apple does not expose the current API key's role. */
@Serializable
data class StoreConnectionCheckDto(
    val storeAppRef: String,
    val listing: StoreCapabilityStatus,
    val screenshots: StoreCapabilityStatus,
)
